import React, { useState, useEffect } from 'react';
import Icons from '../../assets/index';

export type ToastType = 'success' | 'error';

export interface ToastProps {
  title: string;
  message?: string;
  type?: ToastType;
  duration?: number;
  onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({
  title,
  message,
  type = 'success',
  duration = 3000,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = type === 'success' ? 'bg-ds-green-100' : 'bg-ds-red-100';

  return (
    <div
      className={`fixed bottom-4 right-4 max-w-sm w-full shadow-lg rounded-md border  ${bgColor} transition-opacity duration-300 ${visible ? 'opacity-100' : 'opacity-0'}`}
    >
      <div className="p-4 flex items-start">
        <div className={`flex-shrink-0 mt-1 `}>
          {type === 'success' ? <Icons.successIcon /> : <Icons.errorIcon />}
        </div>
        <div className={`ml-3 flex-1 `}>
          <p className="text-sm font-semibold text-ds-gray-700">{title}</p>
          {message && <p className="text-sm  text-ds-gray-500">{message}</p>}
        </div>
        <button
          data-testid="close-toast"
          type="button"
          className={`ml-4 flex-shrink-0  hover:opacity-75 focus:outline-none text-ds-gray-500`}
          onClick={() => {
            setVisible(false);
            if (onClose) setTimeout(onClose, 2000);
          }}
        >
          <Icons.closeIcon />
        </button>
      </div>
    </div>
  );
};

export default Toast;
